import axios from 'axios';
import '../App.css';
import { useEffect, useState } from 'react';
import DevStatsTopCampaignsItem from './DevStatsTopCampaignsItem';

function DeviceStatsTopCampaigns({ device_id }) {
    const [campaigns, setCampaigns] = useState([]);

    function getTopCampaigns() {
        axios.get(
            process.env.REACT_APP_API_HOST + `/device/stats/campaigns/?device_id=${device_id}`
        ).then(
            (response) => {
                setCampaigns(response.data);
            }
        )
    }

    const divCampaigns = campaigns.map(
        c =>
            <DevStatsTopCampaignsItem
                campaign_id={c.campaign_id}
                impressions_count={c.dcount}
            />
    );

    useEffect(
        () => {
            getTopCampaigns();
        },
        [],
    )

    return (
        <div>
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <h4>
                    Top Campaigns
                </h4>
            </div>
            <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                {divCampaigns}
            </div>
        </div>
    );
}

export default DeviceStatsTopCampaigns;